exports.themes = {
  colors: {
    blue: "#2697c0",
    brightBlue: "#1e87f0",
    grey: "#323232"
  }
};
